/* angular2-moment (c) 2015, 2016 Uri Shaked / MIT Licence */
"use strict";
var core_1 = require('@angular/core');
var moment = require('moment');
var AddPipe = (function () {
    function AddPipe() {
    }
    AddPipe.prototype.transform = function (value, amount, unit) {
        if (typeof amount === 'undefined' || (typeof amount === 'number' && typeof unit === 'undefined')) {
            throw new Error('AddPipe: missing required arguments');
        }
        return moment(value).add(amount, unit);
    };
    AddPipe.decorators = [
        { type: core_1.Pipe, args: [{ name: 'amAdd' },] },
    ];
    /** @nocollapse */
    AddPipe.ctorParameters = [];
    return AddPipe;
}());
exports.AddPipe = AddPipe;
//# sourceMappingURL=add.pipe.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular2-moment/add.pipe.js
// module id = 415
// module chunks = 3